module.exports = __webpack_public_path__ + "static/devcon4-2-e57c41d22a5e8227d3886c44b2451595.jpg";